import { z } from 'zod'

export const linkedValueStatusSchema = z.enum(['ok', 'unavailable'])
export type LinkedValueStatus = z.infer<typeof linkedValueStatusSchema>

export const linkedValueSourcePrecisionSchema = z.enum(['date', 'datetime'])
export type LinkedValueSourcePrecision = z.infer<typeof linkedValueSourcePrecisionSchema>

export const patientOverviewItemSchema = z.object({
  label: z.string(),
  value: z.string().nullish(),
  since: z.string().nullish(),
  editable: z.boolean(),
  assignOnly: z.boolean().default(false),
  seriesSlug: z.string().nullish(),
  fieldName: z.string().nullish(),
  options: z.array(z.object({ label: z.string(), value: z.string() })).nullish(),
  attributeId: z.string(),
  showRtmPopup: z.boolean(),
  displayColumn: z.string().nullish(),
  status: linkedValueStatusSchema.nullish(),
  source: z.string().nullish(),
  sourceAt: z.string().nullish(),
  sourcePrecision: linkedValueSourcePrecisionSchema.nullish(),
})
export type PatientOverviewItem = z.infer<typeof patientOverviewItemSchema>

export const patientOverviewItemsSchema = z.array(patientOverviewItemSchema)
export type PatientOverviewItems = z.infer<typeof patientOverviewItemsSchema>

export const patientOverviewItemsPath = (patientUuid: string): string =>
  `/patients/${patientUuid}/overview-items`
